import {RefControlBlock} from "../StyleBox";
import React, {useState} from "react";
import MandatoryBtn from "./schedule/MandatoryBtn";
import ConditionBtn from "./schedule/ConditionBtn";
import RemoveBtn from "./schedule/RemoveBtn";
import {isEnvProduction, isExcludeOID} from "../../../lib/ODMUtils";
import {useSelector} from "react-redux";

const RefControlOption = ({metaData, defOID, refInfo, refItem, refType, onDeleteRef, toggleMandatory, onChangeCondition}) => {

    const metaDataStore = useSelector(({metaDataStore}) => metaDataStore);
    const isProd = isEnvProduction(metaDataStore);

    const [conditionVisible, setConditionVisible] = useState(false);
    const [removeVisible, setRemoveVisible] = useState(false);

    const getVisible = () => {
        return (conditionVisible || removeVisible);
    }

    return (
        <RefControlBlock visible={getVisible()}>
            {/*Mandatory 버튼 숨김 처리 2026-02-12*/}
            {/*<MandatoryBtn defOID={defOID} refInfo={refInfo} refItem={refItem} toggleMandatory={toggleMandatory} isProd={isProd} />*/}
            {/*Mandatory 관련 없이 Condition 걸리도록 수정 2025-01-22 #1693*/}
            {/*Form에만 Condition 버튼 표시되도록 수정 2026-02-12*/}
            {
                (refType === 'formRef') &&
                <ConditionBtn defOID={defOID} refItem={refItem} refInfo={refInfo} onChangeCondition={onChangeCondition}
                              metaData={metaData} visible={conditionVisible} setVisible={setConditionVisible} isProd={isProd} />
            }
            {
                (!isProd && !isExcludeOID(refInfo?.oid)) &&
                <RemoveBtn refInfo={refInfo} defOID={defOID} refType={refType} visible={removeVisible} setVisible={setRemoveVisible} onDeleteRef={onDeleteRef} />
            }
        </RefControlBlock>
    )

}

export default RefControlOption;